import { CaretRightOutlined } from '@ant-design/icons';
import React from 'react';
import { Collapse, theme } from 'antd';
const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;
const getItems = (panelStyle) => [
	{
		key: '1',
		label: 'Day 1',
		children: <p>{text}</p>,
		style: panelStyle,
	},
	{
		key: '2',
		label: 'Day 2',
		children: <p>{text}</p>,
		style: panelStyle,
	},
	{
		key: '3',
		label: 'Day 3',
		children: <p>{text}</p>,
		style: panelStyle,
	},
];
const Faq = () => {
	const { token } = theme.useToken();
	const panelStyle = {
		marginBottom: 24,
		background: '#f2f2f2',
		borderRadius: token.borderRadiusLG,
		border: 'none',
	};
	return (
		<Collapse
			bordered={false}
			defaultActiveKey={['1']}
			expandIcon={({ isActive }) => (
				<CaretRightOutlined rotate={isActive ? 90 : 0} />
			)}
			style={{
				background: '',
			}}
			items={getItems(panelStyle)}
		/>
	);
};
export default Faq;
